// extracted by mini-css-extract-plugin
export default {"root":"ErrorScreen_root-KKx","title":"ErrorScreen_title-Te7","label":"ErrorScreen_label-ALa","actions":"ErrorScreen_actions-DxO"};